import { createLocaleTextHook, CORE_TEXT } from '@moonpig/web-core-locale-text'
import { FORGOTTEN_PASSWORD_TEXT } from '../components/ForgottenPassword/forgottenPassword.locale'
import { FAVOURITES_TEXT } from '../pages/favourites/favourites.locale'
import { MY_ACCOUNT_TEXT } from '../pages/my-account/my-account.locale'
import { ACCOUNT_TEXT } from './localeText'
import { ADDRESS_BOOK_TEXT } from '../pages/address-book/address-book.locale'
import { ACCOUNT_DETAILS_TEXT } from '../pages/account-details/account-details.locale'
import { MY_SAVED_CARDS_LOCALE_TEXT } from '../components/SavedCards/SavedCards.locale'

const dictionary = {
  ...ACCOUNT_TEXT,
  ...FAVOURITES_TEXT,
  ...MY_ACCOUNT_TEXT,
  ...CORE_TEXT,
  ...FORGOTTEN_PASSWORD_TEXT,
  ...ADDRESS_BOOK_TEXT,
  ...ACCOUNT_DETAILS_TEXT,
  ...MY_SAVED_CARDS_LOCALE_TEXT,
}

export const useAccountLocaleText = createLocaleTextHook({
  dictionary,
})
